export const PAGE_ERROR = {
    INVALID_PARENT: "INVALID_PARENT",
    NO_PAGES: "NO_PAGES",
    NOT_ALLOWED: "NOT_ALLOWED",
    NOT_FOUND: "NOT_FOUND",
    LAST_PAGE: "LAST_PAGE",
    PAGE_IS_CONTAINER: "PAGE_IS_CONTAINER"
};
